// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"956b6a6b","238":"b88e7586","256":"77c36795","302":"1b0a33b0","323":"e17d669d","372":"614b3d4b","453":"e9e7ec89","524":"493524f0","585":"065dc021","624":"5c59d96b","632":"6295f4b1","663":"a1e72fe0","678":"abd85e90"}[chunkId] + ".chunk.js";
};